import requestMgr from "app/requestMgr";
import loadingMgr from "app/loadingMgr";

const requestInstance = requestMgr.getInstance();
const loadingInstance = loadingMgr.getInstance();

function doRequest(...arg) {
  return requestInstance.doRequest(...arg);
}

function setLoading(...arg) {
  loadingInstance.setSpinner(...arg);
}

export { doRequest, setLoading };
